<template>
  <el-dialog
    title="是否取消备货出库"
    :visible.sync="cancelPareVisible"
    width="30%"
    :append-to-body="true"
    class="cancelPareDialog"
  >
    <p>主订单号:<span class="orderNo">{{orderNoGroups}}</span></p>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="cancelPareVisible = false" size="small">取 消</el-button>
      <el-button
        type="primary"
        size="small"
        @click="confirmCancel"
      >确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  data () {
    return {
      cancelPareVisible: false,
      orderNoGroups: ''
    }
  },
  methods: {
    confirmCancel () {
      this.$emit('cancelOrder')
      this.cancelPareVisible = false
    }
  }
}
</script>
<style lang="scss">
.cancelPareDialog {
  .orderNo {
    color:#409EFF;
  }
  .el-dialog__title {
    font-size: 14px !important;
    font-weight: bold;
  }
  .el-dialog__body {
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order/cancelPare-dialog.vue